import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import ExperienceTimeline from "../components/experience/experienceTimeline";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/experience.css";

const Experience = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "projects");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`About | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="experience-container">
				<div className="title experience-title">
					{INFO.experience.title}
				</div>

				<div className="subtitle experience-subtitle">
					{INFO.experience.description}
				</div>

				<div className="timeline-container">
					<ExperienceTimeline />
				</div>
			</div>
		</React.Fragment>
	);
};

export default Experience;
